export default __webpack_public_path__ + "static/media/biadh.d2411eba.mp3";